import { Routes } from '@angular/router';
import { EditTypeInteractionComponent } from './edit-type-interaction/edit-type-interaction.component';
import { ListeTypeInteractionsComponent } from './liste-type-interactions/liste-type-interactions.component';

export const TYPE_INTERACTIONS_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const TYPE_INTERACTIONS_ROUTES: Routes = [
    { path: '', component: ListeTypeInteractionsComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditTypeInteractionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditTypeInteractionComponent, data: { roles: ['ORGANISME'] } }
];
